import InputField from "../../../components/InputField";

export default function ContractStep({ data, errors, update }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <InputField label="Numar contract" value={data.contractNumar} onChange={update("contractNumar")} placeholder="ex: 123" half error={errors.contractNumar} />
      <InputField label="Data semnarii contractului" value={data.contractData} onChange={update("contractData")} type="date" required half error={errors.contractData} />
      <InputField label="Adresa imobilului inchiriat" value={data.contractAdresaImobil} onChange={update("contractAdresaImobil")} placeholder="ex: Str. Exemplu nr. 1, ap. 5, Bucuresti" required error={errors.contractAdresaImobil} />
    </div>
  );
}
